import type { IImageField } from '@/typescript/interfaces/IImageField';
import type { ITextField } from '@/typescript/interfaces/ITextField';

export function sortFields(fields: ITextField[] | IImageField[]): (IImageField | ITextField)[] {
    const imgFields: IImageField[] = [];
    const textFields: ITextField[] = [];
    fields.forEach((field) => {
        if ((field as ITextField)?.text || (field as ITextField)?.defaultText) {
            textFields.push(field as ITextField);
        } else {
            imgFields.push(field as IImageField);
        }
    });
    return [...imgFields, ...textFields];
}
